<template>
  <div class="bg-block shadow-primaryBlock rounded
              px-8 py-8 lg:px-12 lg:pt-13 lg:pb-10 relative"
       :class="fitContent ? 'self-start' : 'h-full'">
    <div class="mb-13" v-if="!!$slots.top">
      <div class="-mx-8 lg:-mx-12 -mt-8 lg:-mt-13  rounded-t
              px-8 pt-8 pb-8 lg:px-12 lg:pt-13 lg:pb-11
              bg-white-top-gradient">
        <slot name="top"/>
      </div>
    </div>
    <slot/>
  </div>
</template>

<script>
export default {
  name: "TopGradientBlockLayout",
  props: {
    fitContent: {
      type: Boolean,
      default: false
    }
  }
}
</script>